<template>
  <div>
      <div class="flex justify-between items-center">
        <span class="font-semibold text-gray-dark">Code snippet for <code class="text-black">&lt;head&gt;</code></span>
        <div class="flex">
          <base-button v-if="showUnreleased"
                       variant="transparent-primary"
                       @click="$emit('go-to-theme')"
          >
            Edit theme
            <PaletteIcon class="h-5 w-5"/>
          </base-button>
          <base-button variant="transparent-primary" @click="copyCodeSnippet">
            Copy
            <CopyIcon class="h-5 w-5" :is-copied="isCodeSnippetCopied"/>
          </base-button>
        </div>
      </div>

      <PrismComponent class="rounded-lg max-h-96" language="html">{{ codeSnippetText }}</PrismComponent>
  </div>
</template>

<script>
import BaseButton from '@/components/base-components/BaseButton.vue'
import PrismComponent from 'vue-prism-component'
import 'prismjs/components/prism-javascript'
import 'prismjs/themes/prism.css'
import CopyIcon from '@/assets/images/icons/CopyIcon.vue'
import PaletteIcon from '@/assets/images/icons/PaletteIcon.vue'

export default {
  name: 'SettingsBotSnippetGoogleTagManager',
  components: { BaseButton, PrismComponent, CopyIcon, PaletteIcon },
  props: {
    codeSnippetText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isCodeSnippetCopied: false
    }
  },
  methods: {
    async copyCodeSnippet() {
      this.$copyText(this.codeSnippetText)
      this.isCodeSnippetCopied = true
      await this.sleep(2000)
      this.isCodeSnippetCopied = false
    }
  }
}
</script>
